import React, { useState } from "react";
import imageOnTheWay from "../../../../public/assets/images/imageOnTheWay.webp";
import { useNavigate } from "react-router";
import { getLatestLisiting } from "@/api/savedPreference";
import { useDispatch, useSelector } from "react-redux";
import ReadOnlyModal from "../My Profile/ReadOnlyModal/ReadOnlyModal";
import { getOfferDetails } from "@/api/bids";
import { IoAlertCircleOutline } from "react-icons/io5";
import ConfirmOffer from "../MyBids/ConfirmOffer/ConfirmOffer";
import OfferDetailsModal from "./OfferDetailModal/OfferDetailsModal";
import { Modal } from "react-bootstrap";
import { acceptOfferApi, getPropertyOffer, rejectOfferApi, withDrawOffer } from "@/api/offers";
import { toast } from "react-toastify";
import CounterOffer from "./CounterOffer";
import { trackApiCall, trackButtonClick } from "@/utils/analytics";
import { setOfferData } from "@/redux/PDP/pdpSlice";
import { getPropertyURL } from "@/utils/propertyNavigation";
import { markInternalNavigation } from "@/utils/attributionCapture";

const OfferDetailsCard = ({
  data,
  bidDetailsById,
  componentType,
  onOfferDetailsClick,
  loading,
  cifArray,
  setReload
}) => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const [showDetails, setShowDetails] = useState(false);
  const [openConfirmOffer, setOpenConfirmOffer] = useState(false);
  const [confirmOfferListingId, setConfirmOfferListingId] = useState("");
  const [offerData, setOfferDataState] = useState({});
  const [offerId, setOfferId] = useState("");
  const [showStatus, setShowStatus] = useState(false);
  const [showWithDraw, setShowWithDraw] = useState(false);
  const [withDrawData, setWithDrawData] = useState({});
  const OFFERS_PER_PAGE = 5;
const [currentPageMap, setCurrentPageMap] = useState({});
const [withOrReject,setWithOrReject] = useState("");
const [showCounter,setShowCounter] = useState(false);
const [counterId,setCounterId] = useState("");
const [acceptPrice,setAccpetPrice] = useState("")
const dispatch = useDispatch();
const [loadingWithDraw,setLoadingWithDraw] = useState(false)
const handlePageChange = (propertyId, direction, totalOffers) => {
  setCurrentPageMap((prev) => {
    const current = prev[propertyId] || 1;
    let nextPage = direction === "next" ? current + 1 : current - 1;
    const totalPages = Math.ceil(totalOffers / OFFERS_PER_PAGE);
    if (nextPage < 1) nextPage = 1;
    if (nextPage > totalPages) nextPage = totalPages;
    return {
      ...prev,
      [propertyId]: nextPage,
    };
  });
}


  const OFFER_ACTION_MAPPING = {
    BUYER_ACCEPT: "Buyer Accepted",
    BUYER_COUNTER: "Buyer Countered",
    BUYER_EXPIRED: "Buyer Offer Lapsed",
    BUYER_HNB: "Buyer Highest & Best",
    BUYER_REJECT: "Buyer Rejected",
    BUYER_WITHDRAWAL: "Buyer Withdrawn",
    CREATED: "Initial Offer",
    CREATE_EXPIRED: "Offer Expired",
    FALLOUT: "Fallout",
    SELLER_ACCEPT: "Seller Accepted",
    SELLER_COUNTER: "Seller Countered",
    SELLER_EXPIRED: "Seller Offer Lapsed",
    SELLER_HNB: "Seller Highest & Best",
    SELLER_REJECT: "Seller Rejected",
    SELLER_RESPONSE_PENDING: "Pending",
    SELLER_WITHDRAW: "Seller Withdrawn",
  };

  const getButtonText = (type, amount) => {
    switch (type) {
      case "BACKUP_OFFER_CTA":
      case "SELLER_REJECT":
        return "Place Backup Offer";
      case "NEW_OFFER_CTA":
        return "Place New Offer";
      case "WITHDRAW_OFFER_CTA":
        return "Withdraw";
      case "CONFIRM_NEGOTIATION":
        return `Confirm Offer for ${amount}`;
      case "ACCEPT_OFFER_CTA":
        return "Accept";
      case "HNB_OFFER_CTA":
        return "Place H & B"
    }
  };
  const showBidDetails = async (id) => {
    const data = await getOfferDetails(id);
    setOfferDataState(data?.offerdetails);
    setShowDetails(true);
    setOfferId(id);
  };
  const redirectToOffer = async (item, type) => {
    if (type?.includes("Confirm Offer")) {
      setOpenConfirmOffer(true);
      //   let confirmOfferData = data?.bidOfferDetailList?.filter(
      //     (d) => d?.bidOfferSummary?.bidOfferId === item?.bidOfferId
      //   );
      setConfirmOfferListingId(item?.propertyDetail?.listingId);
    } else if (type?.includes("Withdraw")) {
      // withDraw(item);
      setShowWithDraw(true);
      setWithDrawData(item);
      setWithOrReject("With")
    } else if (type?.includes("Accept")){

      setShowWithDraw(true);
      setWithDrawData(item);
      setWithOrReject("Accept")
      setAccpetPrice(item?.activeOffer?.offerAmount)
    }
    else if (type?.includes("H & B")){
      setShowCounter(true)
      setWithOrReject("hnb")
       setWithDrawData(item);
      setCounterId(item?.activeOffer?.offerId)
    }
    else {
      const data = await getLatestLisiting({
        propertyId: item?.propertyDetail?.propertyId,
      });
      let offerType =
        type === "Place New Offer" ? "PLACE_OFFER" : "PLACE_BACKUP_OFFER";
      const state = {
        listingId: item?.propertyDetail?.listingId,
        userId: user?.user?.realbidUserId,
        offerAmount: data?.minimumOfferAmount,
        offerType,
      };

      dispatch(setOfferData(state))
      navigate("/offer", { state: state });
    }
  };

  const handleClose = (options  = {}) => {
    const { onTextClick = false } = options
    setShowWithDraw(false);
    onTextClick &&
      trackButtonClick({
        eventName: "withdraw_offer_conf_no_click",
        eventCategory: "My Offers",
        eventSource: "on close click",
        eventLabel: `Offer Id: ${withDrawData?.activeOffer?.offerId}`
      });
  };

  const handleCloseCounter = () =>{
    setShowCounter(false);
  }

  const navigateToEditCif =async(cifid) =>{
    window.open(`/ciOffer/document/${cifid}`);
  }

  const withDraw = async (withDrawData) => {
    try {
      const id = withDrawData?.activeOffer?.offerId;
      setLoadingWithDraw(true)
      const payload = {
        offerId: withDrawData?.activeOffer?.offerId,
        activeOffer: withDrawData?.activeOffer?.offerId,
        propertyId: withDrawData?.propertyDetail?.propertyId,
        buyerDetail: `${withDrawData?.buyerDetail?.emailId}|${withDrawData?.buyerDetail?.firstName}|${withDrawData?.buyerDetail?.lastName}`,
      };

      const data = await withDrawOffer({ id, payload });
      handleClose();
      if (data?.status === "SUCCESS") {
        trackApiCall({
          eventName: "withdraw_offer_success",
          eventCategory: "My Offers",
          eventSource: "on confirm click success",
          eventLabel: `Offer Id: ${withDrawData?.activeOffer?.offerId}`,
        })
      setLoadingWithDraw(false)
        const resp = await getPropertyOffer({ id, payload });
        if (resp.status === "SUCCESS") {
          toast.success("Offer Withdrawn successfully");
          setReload(true)
        } else {
          toast.error(data?.errorMessage);
          setReload(false)
           setLoadingWithDraw(false)
        }
      } else {
        toast.error(data?.errorMessage);
        setReload(false)
         setLoadingWithDraw(false)
      }
    } catch (error) {
      console.log(error);
      setReload(false)
       setLoadingWithDraw(false)
    }
  };
  const reject = async (withDrawData) => {
    try {
      const id = withDrawData?.activeOffer?.offerId;
      const payload = {
        offerId: withDrawData?.activeOffer?.offerId,
        activeOffer: withDrawData?.activeOffer?.offerId,
        propertyId: withDrawData?.propertyDetail?.propertyId,
        buyerDetail: `${withDrawData?.buyerDetail?.emailId}|${withDrawData?.buyerDetail?.firstName}|${withDrawData?.buyerDetail?.lastName}`,
      };
      const data = await rejectOfferApi({ id, payload });
      handleClose();
      if (data?.status === "SUCCESS") {
        const resp = await getPropertyOffer({ id, payload });
        if (resp.status === "SUCCESS") {
          toast.success("Offer Rejected successfully");
          setReload(true)
        } else {
          toast.error(data?.errorMessage);
          setReload(false)
        }
      } else {
        toast.error(data?.errorMessage); setReload(false)
      }
    } catch (error) {
      console.log(error);
       setReload(false)
    }

  }

  const accept = async(withDrawData) =>{
      try {
      const id = withDrawData?.activeOffer?.offerId;
      const payload = {
        offerId: withDrawData?.activeOffer?.offerId,
        activeOffer: withDrawData?.activeOffer?.offerId,
        propertyId: withDrawData?.propertyDetail?.propertyId,
        buyerDetail: `${withDrawData?.buyerDetail?.emailId}|${withDrawData?.buyerDetail?.firstName}|${withDrawData?.buyerDetail?.lastName}`,
      };
      const data = await acceptOfferApi({ id, payload });
      handleClose();
      if (data?.status === "SUCCESS") {
        const resp = await getPropertyOffer({ id, payload });
        if (resp.status === "SUCCESS") {
          toast.success("Your Offer has been successfully accepted");
           setReload(true)
        } else {
          toast.error(data?.errorMessage);
           setReload(false)
        }
      } else {
        toast.error(data?.errorMessage);
         setReload(false)
      }
    } catch (error) {
      console.log(error);
       setReload(false)
    }


  }
  return (
    <>
      <div>
        {data?.map((data, id) => (
          <div className={`  ${
                OFFER_ACTION_MAPPING[data?.activeOffer?.offerActivity]==="Seller Highest & Best"?"hnb-color":OFFER_ACTION_MAPPING[data?.activeOffer?.offerActivity]==="Seller Countered"?"seller-counter-color" :""
              } myoffer-card-border mx-0 mx-md-3`}>
                <p className="title-for-sller">
              {
                OFFER_ACTION_MAPPING[data?.activeOffer?.offerActivity]==="Seller Highest & Best"?"HIGHEST AND BEST OFFER":OFFER_ACTION_MAPPING[data?.activeOffer?.offerActivity]==="Seller Countered"?"SELLER COUNTER" :""
              }

                </p>
            <div key={id} className="row mb-3 pb-5 m-0 m-md-3">
              <div className="col-12 col-md-2">
                <img
                  src={
                    "/assets/images/no-photo.jpg"
                  }
                  alt="image on the way"
                  className="my-offer-img"
                  height={97}
                  width={145}
                  onClick={() => {
                    markInternalNavigation();
                    navigate(getPropertyURL(`/property/${data?.propertyDetail?.propertyId}`, data?.propertyDetail?.propertyCategory, data?.propertyDetail?.propertyStatus));
                    trackButtonClick({
                      eventName: "property_image_click",
                      eventCategory: "My Offers",
                      eventSource: "On property image click",
                      eventLabel: `Listing Id: ${data?.propertyDetail?.listingId}`,
                    })
                   }
                  }
                />
              </div>
              <div className="my-offer-address-div col-12 col-md-4 py-3">
                <a href={getPropertyURL(`/property/${data?.propertyDetail?.propertyId}`, data?.propertyDetail?.propertyCategory, data?.propertyDetail?.propertyStatus)}>
                  <p
                    className="my-offer-address-div-p p-0 m-0"
                    onClick={() => {
                      trackButtonClick({
                        eventName: "address_link_click",
                        eventCategory: "My Offers",
                        eventSource: "On property address click",
                        eventLabel: `Listing Id: ${data?.propertyDetail?.listingId}`,
                      })
                     }
                    }
                  >
                    {data?.propertyDetail?.propertyAddress?.streetNumber}{" "}
                    {data?.propertyDetail?.propertyAddress?.streetName}
                    {" , "}
                    {data?.propertyDetail?.propertyAddress?.city}
                    {" , "}
                    {data?.propertyDetail?.propertyAddress?.state}
                    {" , "}
                    {data?.propertyDetail?.propertyAddress?.zip}
                  </p>
                </a>
                <p className="my-offer-action p-0 m-0">
                  Offer Action :{" "}
                  <span className="roboregular">
                    {OFFER_ACTION_MAPPING[data?.activeOffer?.offerActivity]}
                  </span>
                </p>
                <p className="my-offer-amount p-0 m-0">
                  Offer Amount :{" "}
                  <span className="roboregular">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).format(data?.activeOffer?.offerAmount)}
                  </span>
                </p>
                <p
                  className="my-offer-details p-0 m-0"
                  onClick={() => {
                    showBidDetails(data?.activeOffer?.offerId);
                    trackButtonClick({
                      eventName: "view_offer_details_click",
                      eventCategory: "My Offers",
                      eventSource: "On offer details click",
                      eventLabel: `Offer Id: ${data?.activeOffer?.offerId}`,
                      eventParams: { section: "active_offer" },
                    });
                  }}
                >
                  {" "}
                  Offer Details{" "}
                </p>
              </div>
              <div className="my-offer-status col-12 col-md-3">
                {data?.additionalOffers && (
                  <>
                    <img
                      src="../assets/images/offerhistory_icon.png"
                      alt=""
                      onClick={() => {
                        console.log(data)
                        setShowStatus(!showStatus)
                        trackButtonClick({
                          eventName: "view_all_offers_click",
                          eventCategory: "My Offers",
                          eventSource: "On offer details icon click",
                          eventLabel: `${showStatus} | Listing Id: ${data?.propertyDetail?.listingId}`,
                        })
                      }}
                      className="cursor-pointer"
                    />
                  </>
                )}
              </div>
              <div className="my-offer-buttons-action col-12 col-md-3 text-left">
                <div className="text-center text-sm-end">
                   {data?.activeOffer?.ctaButtons?.length>0 &&
                  <button
                    className="btn my-1 p-2 btn-sm auction-thm w-50 robolight"
                    onClick={() => {
                      setWithOrReject(getButtonText(
                      data?.activeOffer?.ctaButtons[0]?.type,
                      data?.activeOffer?.offerAmount==="Place H & B"?"hnb":""
                      ))
                      redirectToOffer(
                        data,
                        getButtonText(data?.activeOffer?.ctaButtons[0]?.type)
                      )
                      trackButtonClick({
                        eventName: "offer_action_click",
                        eventCategory: "My Offers",
                        eventSource: "On offer action click",
                        eventLabel: `Offer Id: ${data?.activeOffer?.offerId} | Listing Id: ${data?.propertyDetail?.listingId}`,
                        eventParams: {
                          button_text: getButtonText(
                            data?.activeOffer?.ctaButtons[0]?.type,
                            data?.activeOffer?.offerAmount
                          ),
                        },
                      });
                    }
                   }
                  >
                    {getButtonText(
                      data?.activeOffer?.ctaButtons[0]?.type,
                      data?.activeOffer?.offerAmount
                    )}
                  </button>
                    }
                </div>
                {
                  data?.activeOffer?.ctaButtons?.length > 1 &&
                  data?.activeOffer?.ctaButtons[1]?.type ===
                    "COUNTER_OFFER_CTA" && data?.activeOffer?.ctaButtons[2]?.type ===
                    "REJECT_OFFER_CTA" &&
                <div className="d-flex justify-content-end gap-10">
                  {data?.activeOffer?.ctaButtons?.length > 1 &&
                   data?.activeOffer?.ctaButtons[1]?.type ===
                     "COUNTER_OFFER_CTA" && (
                     <button
                       className="withdraw-btn my-1 robolight p-0"
                       onClick={() => {
                        //  setShowWithDraw(true);
                        setWithDrawData(data);
                        setShowCounter(true);
                        setWithOrReject("counter")
                        setCounterId(data?.activeOffer?.offerId)
                        trackButtonClick({
                          eventName: "counter_offer_click",
                          eventCategory: "My Offers",
                          eventSource: "On counter offer click",
                          eventLabel: `Offer Id: ${data?.activeOffer?.offerId}`,
                        })
                       }}
                     >
                       Counter
                     </button>
                   )}
                    {data?.activeOffer?.ctaButtons?.length > 1 &&
                   data?.activeOffer?.ctaButtons[2]?.type ===
                     "REJECT_OFFER_CTA" && (
                     <button
                       className="withdraw-btn my-1 robolight p-0"
                       onClick={() => {
                         setShowWithDraw(true);
                         setWithDrawData(data);
                         setWithOrReject("Reject")
                         trackButtonClick({
                           eventName: "reject_offer_click",
                           eventCategory: "My Offers",
                           eventSource: "On reject offer click",
                           eventLabel: `Offer Id: ${data?.activeOffer?.offerId}`,
                         })
                       }}
                     >
                       Reject
                     </button>
                   )}

                </div>
                }
                {data?.activeOffer?.ctaButtons?.length > 1 &&
                  data?.activeOffer?.ctaButtons[1]?.type ===
                    "WITHDRAW_OFFER_CTA" && (
                    <button
                      className="withdraw-btn my-1 robolight p-0"
                      onClick={() => {
                        setShowWithDraw(true);
                        setWithDrawData(data);
                        setWithOrReject("With")

                        trackButtonClick({
                          eventName: "withdraw_offer_click",
                          eventCategory: "My Offers",
                          eventSource: "On withdraw offer click",
                          eventLabel: `Offer Id: ${data?.activeOffer?.offerId}`,
                        })
                      }}
                    >
                      Withdraw
                    </button>
                  )}
                {Object.keys(cifArray)?.includes(
                  data?.activeOffer?.offerId
                ) && (
                  <div className="d-flex my-1 justify-content-start align-items-baseline">
                    <span
                      className="text-danger fs20 span-tool"
                      data-bs-toggle="tooltip"
                      title="The information provided in this form will be used to complete the contract documentation for the property if your bid is selected for this property. An early submission of your contact information will help us to process and close documentation sooner in the event your bid is selected."
                    >
                      <IoAlertCircleOutline color="red" height={"24px"} width={"24px"} className="fs24"/>
                    </span>
                    <button
                      className={`robolight p-0 ${cifArray[data?.activeOffer?.offerId]?.currentCifStep ===
                      "CI_UPFRONT_READY"?"withdraw-btn-cif-complete":"withdraw-btn"}`}
                      onClick={() => {
                        trackButtonClick({
                          eventName: "cif_link_clicked",
                          eventCategory: "My Offers",
                          eventSource: "On edit contact information click",
                          eventLabel: `openCifForm| Offer Id: ${data?.activeOffer?.offerId} | Edit contact information form`,
                        })
                        navigateToEditCif(cifArray[data?.activeOffer?.offerId]?.cifId)
                      }
                     }
                    >
                      {cifArray[data?.activeOffer?.offerId]?.currentCifStep ===
                      "CI_UPFRONT_READY"
                        ? "Complete contact information form"
                        : "Edit contact information form"}
                    </button>
                  </div>
                )}
              </div>
            </div>
            {showStatus && (
              <div className="offer-hist">
               <div className="d-flex justify-content-between align-items-center offer-hist-head pb-3">
  <h4 className="m-0">
    Offer History ({data?.additionalOffers?.length})
  </h4>
  {data?.additionalOffers?.length > OFFERS_PER_PAGE && (
    <div className="d-flex gap-2 align-items-center">
      <button
        className="link-btn-np"
        disabled={
          (currentPageMap[data?.propertyDetail?.propertyId] || 1) === 1
        }
        onClick={() => {
          handlePageChange(
            data?.propertyDetail?.propertyId,
            "prev",
            data?.additionalOffers?.length
          );
          trackButtonClick({
            eventName: "offer_pagination_click",
            eventCategory: "My Offers",
            eventSource: "On previous click",
            eventLabel: `Listing Id: ${data?.propertyDetail?.listingId}`,
            eventParams: { direction: "previous", section: "previous_transaction" },
          });
         }
        }
      >
       <i className="fa fa-arrow-left"></i> Previous
      </button>
      <button
        className="link-btn-np"
        disabled={
          (currentPageMap[data?.propertyDetail?.propertyId] || 1) ===
          Math.ceil(data?.additionalOffers?.length / OFFERS_PER_PAGE)
        }
        onClick={() => {
          handlePageChange(
            data?.propertyDetail?.propertyId,
            "next",
            data?.additionalOffers?.length
          );

          trackButtonClick({
            eventName: "offer_pagination_click",
            eventCategory: "My Offers",
            eventSource: "On next click",
            eventLabel: `Listing Id: ${data?.propertyDetail?.listingId}`,
            eventParams: { direction: "next", section: "previous_transaction" },
          });
         }
        }
      >
        Next <i className="fa fa-arrow-right"></i>
      </button>
    </div>
  )}
</div>

                <div className="row m-2 p-2 offer-hist-row">
                  <div className="col-3 offer-hist-row-header">Amount</div>
                  <div className="col-3 offer-hist-row-header">Date</div>
                  <div className="col-6 offer-hist-row-header">Action</div>
                </div>
                    {(() => {
      const page = currentPageMap[data?.propertyDetail?.propertyId] || 1;
      const start = (page - 1) * OFFERS_PER_PAGE;
      const end = start + OFFERS_PER_PAGE;
      const currentOffers = data?.additionalOffers?.slice(start, end);

      return (
        <>
          {currentOffers?.map((additional, id) => (
            <div className="row  m-2 p-2 " key={id}>
              <div className="col-3 offer-hist-row-data offer-row-amt">
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(additional?.offerAmount)}
              </div>
              <div className="col-3 offer-hist-row-data">
                {additional?.placedOn}
              </div>
              <div className="col-6 offer-hist-row-data text-end">
                <button
                  className="my-offer-details-row"
                  onClick={() => {
                    showBidDetails(additional?.offerId)
                    trackButtonClick({
                      eventName: "view_offer_details_click",
                      eventCategory: "My Offers",
                      eventSource: "On offer details click",
                      eventLabel: `Offer Id: ${additional?.offerId}`,
                      eventParams: { section: "previous_transaction" },
                    })
                  }}
                >
                  Offer Details
                </button>
              </div>
            </div>
          ))}


        </>
      );
    })()}
              </div>
            )}
          </div>
        ))}
      </div>

      <OfferDetailsModal
        show={showDetails}
        handleClose={() => setShowDetails(false)}
        offerData={offerData}
        offerId={offerId}
      />

      <ConfirmOffer
        handleClose={() => setOpenConfirmOffer(false)}
        show={openConfirmOffer}
        listingId={confirmOfferListingId}
      />

    {
      showCounter && (
        <CounterOffer
          handleClose={handleCloseCounter}
          show={showCounter}
          type={withOrReject === "counter" ? "counter" : "hnb" }
          id={counterId}
          item={withDrawData}
          setReload={setReload}
        />
      )
    }

      {showWithDraw && (
        <Modal show={showWithDraw} onHide={handleClose}>
          <Modal.Header closeButton className="license-title">
            <Modal.Title className="text-white roboreg">
              {
                withOrReject==="With"?"Confirm Withdraw":withOrReject==="Reject"?"Confirm Reject":"Confirm Accept"
              }
              {" "}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="p-4 text-center roboreg">
              {
                withOrReject==="With"?"Are you sure you want to withdraw your offer?":withOrReject==="Reject"?"Are you sure you want to reject your offer?":`Are you sure you wish to accept this offer for  ${new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0,
                    }).format(acceptPrice)}`
              }

            </p>
            <div className="d-flex justify-content-center">
              <button
                className="mx-2 yes-btn"
                onClick={() => {
                  withOrReject === "With"
                    ? withDraw(withDrawData)
                    : withOrReject === "Reject"
                    ? reject(withDrawData)
                    : accept(withDrawData);

                  trackButtonClick({
                    eventName: "bid_withdraw_conf_yes_click",
                    eventCategory: "My Bids",
                    eventSource: "On withdraw offer click yes",
                    eventLabel: `Offer Id: ${withDrawData?.activeOffer?.offerId}`,
                  })
                }}
              >
                {
                  withOrReject === "With" ? loadingWithDraw ?"Loading...":"Yes":"Yes"
                }
                {/* Yes */}
              </button>
              <button className="no-btn" onClick={()=>handleClose({onTextClick: true})}>No</button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default OfferDetailsCard;
